import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';
import { background } from '../../../../config';


const fadeFromRight = keyframes`
from {
  opacity: 0;
  transform: translateX(50px);
}
to{
  opacity: 1;
  transform:translateX(0);
}
`;
export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h2{
    margin-top: 30px;
    margin-bottom: 15px;

    width: 100%;
    text-align:center;
    font-size: 24px;
    color: #fff;
  }

  .ticket {
    width:  100%;
    max-width: 440px;
    border-radius: 15px;
    background: #fff;
    color: #333;
    display: flex ;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    padding: 15px;
    margin-top: 15px;

    svg{
      margin: 15px ;
      margin-right: 25px;
    }

    strong{
      font-size: 14px;
    }

    p.user{
      font-size: 12px;
    }

     button{
      font-size: 12px;
      border-radius: 5px;
      background: #333;
      color: #fff ;
      cursor:pointer;
      padding: 5px ;
      border: 0px;
      margin-right: 5px;
    }

    div{
      display: flex ;
      align-items: center;
      justify-content: flex-start;
      width: 100% ;
      margin-top: 10px;
    }
  }
  
`;

export const AnimatedDiv = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  width: 100%;
  background: rgba(255,255,255,0.9);
  padding: 20px 20px;
  margin: 10px 0px;
  animation: ${fadeFromRight} 1s;
  border-radius: 10px;

  form {
    margin: 30px 0;
    width: 100%;
    max-width: 100%;
    text-align: center;

    @media (max-width: 750px) {
      padding: 0px 20px;
      width: 100%;
      max-width: 100%;
    }

    h2 {
      margin: 30px 0;
      color: ${'#fff'};
      font-size: 42px;

    }

    a {
      color: ${'#fff'};
      display: block;
      margin-top: 24px;
      text-decoration: none;

      transition: color 0.2s;

      &:hover {
        color: ${shade(0.2, '#fff')};
      }
    }
  }

  > a {
    color: #fff;
    display: block;
    margin-top: 24px;
    text-decoration: none;

    transition: color 0.2s;

    &:hover {
      color: ${shade(0.2, '#fff')};
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 450px;

  z-index: 1;

  @media (max-width: 750px) {
    width: 100%;
  }

  img {
    width: 300px;
    max-width: 100%;
    margin: 10px;


  }
`;

export const Background = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: url(${background}) no-repeat top left;
  background-size: cover;
  width: 100%;
  height: 100vh;
  z-index: 0;
`;
